import { render, staticRenderFns } from "./CellRendererLink.vue?vue&type=template&id=0abb35a8&scoped=true"
import script from "./CellRendererLink.vue?vue&type=script&lang=js"
export * from "./CellRendererLink.vue?vue&type=script&lang=js"
import style0 from "./CellRendererLink.vue?vue&type=style&index=0&id=0abb35a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abb35a8",
  null
  
)

export default component.exports